(function () {
  'use strict';

  function prefersReducedMotion() {
    try {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) {
      return false;
    }
  }

  function formatMoney(cents) {
    var amount = parseInt(String(cents || '0'), 10) || 0;
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try {
        return window.Shopify.formatMoney(amount);
      } catch (e) {}
    }
    try {
      return new Intl.NumberFormat('nl-NL', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(amount / 100);
    } catch (e2) {
      return '€ ' + (amount / 100).toFixed(2).replace('.', ',');
    }
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function shuffleInPlace(arr) {
    if (!Array.isArray(arr)) return arr;
    for (var i = arr.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = arr[i];
      arr[i] = arr[j];
      arr[j] = tmp;
    }
    return arr;
  }

  function fetchCardHtml(handle) {
    handle = String(handle || '').trim();
    if (!handle) return Promise.resolve('');

    var url =
      '/products/' + encodeURIComponent(handle) + '?section_id=ss-gerelateerde-producten-card';

    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('card fetch failed');
        return r.text();
      })
      .catch(function () {
        return '';
      });
  }

  function fetchCollectionProducts(handle, perLimit) {
    if (!handle) return Promise.resolve([]);

    var limit = parseInt(perLimit, 10);
    if (!Number.isFinite(limit) || limit <= 0) limit = 50;

    var url =
      '/collections/' +
      encodeURIComponent(handle) +
      '/products.json?limit=' +
      encodeURIComponent(limit);

    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('collection failed');
        return r.json();
      })
      .then(function (data) {
        var list = Array.isArray(data) ? data : Array.isArray(data.products) ? data.products : [];
        return list;
      })
      .catch(function () {
        return [];
      });
  }

  function themeKeyToHandle(key) {
    var s = String(key || '').trim().toLowerCase();
    if (!s) return '';
    s = s.replace(/&/g, ' en ');
    s = s.replace(/[^a-z0-9]+/g, '-');
    s = s.replace(/^-+|-+$/g, '');
    return s;
  }

  function collectCartProductHandles() {
    var map = {};
    try {
      var buttons = document.querySelectorAll('.js-ss-edit[data-product-handle]');
      buttons.forEach(function (btn) {
        var h = (btn.getAttribute('data-product-handle') || '').trim();
        if (h) map[h] = true;
      });
    } catch (e) {}
    return map;
  }

  function initSwiper(root) {
    if (!root) return;
    if (typeof Swiper !== 'function') return;

    if (root._ssGerelateerdeSwiper && typeof root._ssGerelateerdeSwiper.destroy === 'function') {
      try {
        root._ssGerelateerdeSwiper.destroy(true, true);
      } catch (e) {}
      root._ssGerelateerdeSwiper = null;
    }

    if (prefersReducedMotion()) return;

    var swiperEl = root.querySelector('.ss-gerelateerde-producten__swiper');
    if (!swiperEl) return;

    var prev = root.querySelector('.ss-gerelateerde-producten__prev');
    var next = root.querySelector('.ss-gerelateerde-producten__next');

    var swiper = new Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 15,
      breakpoints: {
        500: { slidesPerView: 2 },
        767: { slidesPerView: 3 },
        1199: { slidesPerView: 4 },
        1400: { slidesPerView: 5 }
      },
      navigation: {
        nextEl: next,
        prevEl: prev
      }
    });

    root._ssGerelateerdeSwiper = swiper;

    if (window.SSProductCard && typeof window.SSProductCard.equalizeRoot === 'function') {
      try {
        window.SSProductCard.equalizeRoot(root);
      } catch (e) {}
    }
  }

  function buildCardHtml(product) {
    if (!product) return '';

    var url = product.url || ('/products/' + (product.handle || ''));
    var title = product.title || '';

    var priceCents = product.price || product.price_min || 0;
    var compareCents = product.compare_at_price || product.compare_at_price_min || 0;

    if ((!priceCents || priceCents <= 0) && Array.isArray(product.variants)) {
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i];
        if (v && v.available && v.price) {
          priceCents = v.price;
          if (!compareCents && v.compare_at_price) compareCents = v.compare_at_price;
          break;
        }
      }
      if ((!priceCents || priceCents <= 0) && product.variants[0] && product.variants[0].price) {
        priceCents = product.variants[0].price;
        if (!compareCents && product.variants[0].compare_at_price) {
          compareCents = product.variants[0].compare_at_price;
        }
      }
    }

    // Actieproducten SALE uit de fallback-collectie geven via /products.json
    // soms bedragen in euro's (bijv. 0.99 of 2) i.p.v. centen. In dat geval
    // schalen we om naar centen zodat formatMoney geen €0,00 / €0,02 toont.
    if (product._ssIsSaleExtra) {
      if (priceCents > 0 && priceCents < 10) {
        priceCents = Math.round(priceCents * 100);
      }
      if (compareCents > 0 && compareCents < 10) {
        compareCents = Math.round(compareCents * 100);
      }
    }

    var hasDiscount =
      !!product._ssIsSaleExtra ||
      !!product.compare_at_price ||
      !!product.compare_at_price_min ||
      (compareCents && compareCents > priceCents);

    var img = '';
    if (product.featured_image && product.featured_image.src) {
      img = product.featured_image.src;
    } else if (Array.isArray(product.images) && product.images[0]) {
      img = product.images[0].src || product.images[0];
    }
    if (!img) {
      img = 'https://placehold.jp/260x260.png';
    }

    var price = formatMoney(priceCents);
    var compare = hasDiscount ? formatMoney(compareCents) : '';

    return (
      '<div class="product-card-outer">' +
      '  <div class="product-card d-flex flex-column">' +
      '    <div class="product-card__image-wrap relative">' +
      '      <div class="labels">' +
      (hasDiscount ? '<div class="label">Korting</div>' : '') +
      '      </div>' +
      '      <div class="image">' +
      '        <a class="d-flex justify-content-center" href="' +
      escapeHtml(url) +
      '" title="' +
      escapeHtml(title) +
      '">' +
      '          <img src="' +
      escapeHtml(img) +
      '" alt="' +
      escapeHtml(title) +
      '" width="260" height="260" loading="lazy">' +
      '        </a>' +
      '      </div>' +
      '    </div>' +
      '    <div class="product-card__info-wrap d-flex flex-column">' +
      '      <div class="reviews d-flex align-items-center">' +
      '        <div class="jdgm-widget jdgm-preview-badge" data-id="' +
      escapeHtml(product.id) +
      '"></div>' +
      '      </div>' +
      '      <div class="product-card__title title-font">' +
      '        <a href="' +
      escapeHtml(url) +
      '" title="' +
      escapeHtml(title) +
      '">' +
      escapeHtml(title) +
      '</a>' +
      '      </div>' +
      '      <div class="price-wrap d-flex align-items-center">' +
      (compare
        ? '<div class="price-old">' + escapeHtml(compare) + '</div>'
        : '') +
      '        <div class="price-new">' +
      '          <span class="price-new__from">Vanaf</span>' +
      '          <span class="price-new__from">' +
      escapeHtml(price) +
      '</span>' +
      '          <span>per stuk</span>' +
      '        </div>' +
      '      </div>' +
      '      <div class="btn-wrap">' +
      '        <a class="btn btn-accent" href="' +
      escapeHtml(url) +
      '">' +
      '          <span class="btn__text">Bekijk mijn prijs</span>' +
      '          <i class="btn__icon btn__icon--end ss-icon-chevron-right"></i>' +
      '        </a>' +
      '      </div>' +
      '    </div>' +
      '  </div>' +
      '</div>'
    );
  }

  function initAutoFromHandles(root, handles, excludeMap) {
    if (!root) return;

    var limitAttr = root.getAttribute('data-ss-gerelateerde-producten-limit') || '6';
    var limit = parseInt(limitAttr, 10);
    if (!Number.isFinite(limit) || limit <= 0) limit = 6;

    var list = Array.isArray(handles) ? handles.slice() : [];
    list = list
      .map(function (h) {
        return String(h || '').trim();
      })
      .filter(function (h) {
        return h !== '';
      });

    try {
      if (list.length) {
        // Debug voor DEV: laat in de console zien welke handles we proberen.
        console.debug('[ss-gerelateerde-producten] handles auto', list);
      } else {
        console.debug('[ss-gerelateerde-producten] geen geldige handles gevonden');
      }
    } catch (e) {}

    if (!list.length) {
      var wrapEmpty = root.querySelector('.ss-gerelateerde-producten__swiper .swiper-wrapper');
      if (window.Shopify && window.Shopify.designMode) {
        if (wrapEmpty && wrapEmpty.children && wrapEmpty.children.length > 0) {
          initSwiper(root);
        }
        return;
      }
      if (wrapEmpty && wrapEmpty.children && wrapEmpty.children.length > 0) {
        initSwiper(root);
      } else {
        root.style.display = 'none';
      }
      return;
    }

    // Thema-namen → collectie-handles
    var themeKeys = list.slice();
    var handles = themeKeys
      .map(function (k) {
        return themeKeyToHandle(k);
      })
      .filter(function (h) {
        return h !== '';
      });

    if (!handles.length) {
      var wrapEmpty2 = root.querySelector('.ss-gerelateerde-producten__swiper .swiper-wrapper');
      if (window.Shopify && window.Shopify.designMode) {
        if (wrapEmpty2 && wrapEmpty2.children && wrapEmpty2.children.length > 0) {
          initSwiper(root);
        }
        return;
      }
      if (wrapEmpty2 && wrapEmpty2.children && wrapEmpty2.children.length > 0) {
        initSwiper(root);
      } else {
        root.style.display = 'none';
      }
      return;
    }

    var perTheme = Math.max(1, Math.ceil(limit / handles.length));

    var wrapper = root.querySelector('.ss-gerelateerde-producten__swiper .swiper-wrapper');
    if (!wrapper) {
      initSwiper(root);
      return;
    }

    var promises = handles.map(function (collHandle) {
      return fetchCollectionProducts(collHandle, perTheme * 3);
    });

    Promise.all(promises)
      .then(function (arrays) {
        var seen = {};
        var products = [];

        arrays.forEach(function (list) {
          list.forEach(function (p) {
            if (!p || p.id == null) return;
            var id = String(p.id);
            if (seen[id]) return;
            seen[id] = true;
            products.push(p);
          });
        });

        if (excludeMap && typeof excludeMap === 'object') {
          products = products.filter(function (p) {
            var h = p && p.handle ? String(p.handle).trim() : '';
            if (!h) return true;
            return !excludeMap[h];
          });
        }

        if (!products.length) {
          if (wrapper.children && wrapper.children.length > 0) {
            initSwiper(root);
          } else {
            root.style.display = 'none';
          }
          return;
        }

        shuffleInPlace(products);
        if (products.length > limit) {
          products.length = limit;
        }

        var tasks = products.map(function (p) {
          var handle = p.handle ? String(p.handle) : '';
          if (!handle) return Promise.resolve(null);
          return fetchCardHtml(handle).then(function (html) {
            if (!html) return null;
            var slide = document.createElement('div');
            slide.className = 'swiper-slide';
            slide.innerHTML = html;
            return slide;
          });
        });

        Promise.all(tasks)
          .then(function (slides) {
            var valid = slides.filter(function (s) {
              return !!s;
            });

            if (!valid.length) {
              if (wrapper.children && wrapper.children.length > 0) {
                initSwiper(root);
              } else {
                root.style.display = 'none';
              }
              return;
            }

            wrapper.innerHTML = '';
            valid.forEach(function (s) {
              wrapper.appendChild(s);
            });
            initSwiper(root);
          })
          .catch(function () {
            if (wrapper.children && wrapper.children.length > 0) {
              initSwiper(root);
            } else {
              root.style.display = 'none';
            }
          });
      })
      .catch(function () {
        if (wrapper.children && wrapper.children.length > 0) {
          initSwiper(root);
        } else {
          root.style.display = 'none';
        }
      });
  }

  function initOfferteAuto(root) {
    if (!root) return;

    var offerItems = [];
    try {
      if (window.SSOffer && typeof window.SSOffer.load === 'function') {
        offerItems = window.SSOffer.load() || [];
      }
    } catch (e) {}

    if (!offerItems || !offerItems.length) {
      // In de theme editor laten we de section gewoon staan als "leeg" blok.
      if (window.Shopify && window.Shopify.designMode) return;
      root.style.display = 'none';
      return;
    }

    var map = {};
    offerItems.forEach(function (it) {
      if (!it) return;
      var rel = it.relatedHandles;
      var arr = [];
      if (Array.isArray(rel)) {
        arr = rel;
      } else if (typeof rel === 'string') {
        arr = rel.split(',');
      }
      arr.forEach(function (h) {
        var key = String(h || '').trim();
        if (!key) return;
        map[key] = true;
      });
    });

    var themeHandles = Object.keys(map);

    var exclude = {};
    offerItems.forEach(function (it) {
      if (!it) return;
      var h = String(it.handle || '').trim();
      if (!h) return;
      exclude[h] = true;
    });

    initAutoFromHandles(root, themeHandles, exclude);
  }

  function initSection(root) {
    if (!root || root.dataset.ssGerelateerdeInit === '1') return;
    root.dataset.ssGerelateerdeInit = '1';

    var mode = root.getAttribute('data-ss-gerelateerde-producten-mode') || 'collection';
    var page = root.getAttribute('data-ss-gerelateerde-producten-page') || '';

    if (mode === 'auto') {
      if (page === 'offerte') {
        initOfferteAuto(root);
      } else {
        var relatedAttr = root.getAttribute('data-ss-gerelateerde-producten-related') || '';
        var themeKeys = relatedAttr
          .split(',')
          .map(function (h) {
            return h.trim();
          })
          .filter(function (h) {
            return h !== '';
          });
        var excludeMap = collectCartProductHandles();
        initAutoFromHandles(root, themeKeys, excludeMap);
      }
    } else {
      initSwiper(root);
    }
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-ss-gerelateerde-producten]');
    if (!roots.length) return;
    roots.forEach(initSection);
  }

  var resizeTimer = null;
  window.addEventListener('resize', function () {
    if (resizeTimer) clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      var roots = document.querySelectorAll('[data-ss-gerelateerde-producten]');
      if (!roots.length) return;
      roots.forEach(function (root) {
        if (window.SSProductCard && typeof window.SSProductCard.equalizeRoot === 'function') {
          try {
            window.SSProductCard.equalizeRoot(root);
          } catch (e) {}
        }
      });
    }, 150);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('ss:offer:changed', function () {
    var roots = document.querySelectorAll(
      '[data-ss-gerelateerde-producten][data-ss-gerelateerde-producten-page="offerte"][data-ss-gerelateerde-producten-mode="auto"]'
    );
    if (!roots.length) return;
    roots.forEach(function (root) {
      initOfferteAuto(root);
    });
  });

  document.addEventListener('shopify:section:load', function (ev) {
    if (!ev || !ev.target) return;
    if (ev.target.querySelector('[data-ss-gerelateerde-producten]')) {
      initAll();
    }
  });
})();
